const type = 'SET_GENERATED_RECHARGE';

const setGeneratedRecharge = (data) => ({
  data,
  type,
});

export { type };
export default setGeneratedRecharge;
